<mat-card>
    <mat-card-header fxLayoutAlign="center">                
        <mat-card-subtitle><h2>Mes revenus</h2></mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>

        <div fxLayout="row wrap" fxLayoutAlign="space-between center" class="w-100 p-2" id="afficheAddcars">
            <div fxFlex="100" fxFlex.gt-sm="33" fxFlex.sm="33">
                
                <button  mat-icon-button  color="primary" matTooltip="Affichage en Grille" (click)="changeViewType('grid')">
                    <span><mat-icon>grid_view</mat-icon></span>
                </button>
                <button  mat-icon-button  color="primary" matTooltip="Affichage en Liste" (click)="changeViewType('list')">
                    <span><mat-icon>format_list_bulleted</mat-icon></span>
                </button>
               
            </div>
        </div>

        <div class="table-wrapper" *ngIf="viewType==='list'">
            <table mat-table [dataSource]="dataSource" matSort class="w-100">
    
                <!-- Payment number Column -->
                <ng-container matColumnDef="number">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> N° de paiement</th>
                    <td mat-cell *matCellDef="let dataSource">
                        {{dataSource.paiement_number}}
                    </td>
                </ng-container>
    
                <!-- Amount Column -->
                <ng-container matColumnDef="amount">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Montant </th>
                    <td mat-cell *matCellDef="let dataSource">{{dataSource.price_to_be_paid | currency : appService.getCurrency() : 'symbol' :
                        '1.2-2'}}</td>
                </ng-container>
    
                <!-- Renting Column -->
                <ng-container matColumnDef="renting">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Location </th>
                    <td mat-cell *matCellDef="let dataSource">
                        <span>Véhicule : {{dataSource.vehicle}}</span><br>
                        <span>Location du : {{dataSource.date_departure | date:"dd MMMM, yyyy" }}</span>
                    </td>
                </ng-container>
    
                <!-- Payment mode Column -->
                <ng-container matColumnDef="paie_mode">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Moyen de paiement </th>
                    <td mat-cell *matCellDef="let dataSource">{{dataSource.paiement_means_paie}}</td>
                </ng-container>
    
                <!-- Date Column -->
                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
                    <td mat-cell *matCellDef="let dataSource">{{dataSource.date | date:"dd MMMM, yyyy 'à' HH:mm" }}</td>
                </ng-container>
                
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let mespaiements; columns: displayedColumns;"></tr>
            </table>
            <p *ngIf="dataSource && dataSource.data.length === 0" class="py-5 mb-0 text-center">Pas de données disponibles</p>
        </div>

        <div fxLayout="row wrap" fxLayoutAlign="center" class="w-100 p-2" *ngIf="viewType==='grid'">
            <mat-card class="menu-item" [fxLayout]="(viewType == 'grid') ? 'column' : 'row'"
                [ngClass]="[viewType + '-item', 'column-'+column]" fxFlex.gt-sm="30" fxFlex.sm="30"  *ngFor="let item of incomes | paginate: { itemsPerPage: 10, currentPage: p }">
               
                <div fxFlex="100" class="p-3">
                    <div fxLayout="column" fxLayoutAlign="start stretch" class="h-100">
                        <mat-card-content class="mb-0">
                            <mat-icon class="icon-title">payments</mat-icon>
                            <h1 class="title">
                                {{item.price_to_be_paid | currency : appService.getCurrency() : 'symbol' :'1.2-2'}}
                            </h1>
                            <span class="subtitle">Paiement N°_{{item.paiement_number}}</span>
                            <div> 
                                <div class="features">
                                    <span>Véhicule : {{item.vehicle}}</span><br>
                                    <span>Location du : {{item.date_departure | date:"dd MMMM, yyyy" }}</span>
                                </div>
                            </div>
                        </mat-card-content>
                        <mat-card-actions class="m-0 p-0">
                            <div class="divider mt-1">
                                <span class="text-muted text-center">
                                    {{item.date | date:"dd MMMM, yyyy 'a' HH:mm" }} <br>Payée par {{item.paiement_means_paie}}
                                </span>
                            </div>
                        </mat-card-actions>
                    </div>
                </div>
            </mat-card>
            <p *ngIf="incomes && incomes.length === 0" class="py-5 mb-0 text-center">No data available</p> 

        </div>
        <div fxLayout="row wrap" fxLayoutAlign="space-between" class="w-100 p-2">
            <div fxFlex="100" fxFlex.gt-sm="20" fxFlex.sm="20">
                <button  mat-icon-button  color="primary" matTooltip="Rafraichir" (click)="refresh()">
                    <span><mat-icon>refresh</mat-icon> Mise à jour</span>
                </button>
            </div>
            
            <div fxFlex="100" fxFlex.gt-sm="80" fxFlex.sm="80" *ngIf="viewType==='grid'">
                <pagination-controls (pageChange)="p = $event" style="text-align: end;"></pagination-controls>
            </div>
            <mat-paginator [pageSizeOptions]="[5, 10, 25, 50]" class="{{viewType==='list' ? 'block' : 'hidden'}}" ></mat-paginator>
        </div>
    
    </mat-card-content>
</mat-card>